let lenis = null;

export const setLenis = (instance) => {
  lenis = instance;
};

export const scrollToTarget = (target) => {
  if (lenis) {
    lenis.scrollTo(target, { offset: -72, duration: 1.4 });
  } else {
    document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
  }
};
